import React, { useEffect, useState } from 'react';
import styles from './ForgotPasswordUpdate.module.css';
import { CustomButton, CustomInputText, CustomLoader, CustomTitle } from '../../../components';
import { useTranslation } from 'react-i18next';
import { forgotPasswordUpdate } from '../../../services/authService';
import { useLocation, useNavigate } from 'react-router-dom';

const ForgotPasswordUpdate = () => {
    const {t} = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const code = queryParams.get("code");

    const [password, setPassword] = useState<string>('');
    const [confirmPassword, setConfirmPassword] = useState<string>('');
    
    const [helperTextPassword, setHelperTextPassword] = useState<string>('');
    const [helperTextPasswordConfirm, setHelperTextPasswordConfirm] = useState<string>('');

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isPasswordUpdated, setIsPasswordUpdated] = useState<boolean>(false); 

    const isPasswordOk = () => {
        const isPasswordOk = password.length >= 6;
        const isPasswordConfirmOk = password === confirmPassword;

        if (!isPasswordOk && helperTextPassword === '' && password !== '') {
            setHelperTextPassword(t('signin.error_password'));
        } else if (isPasswordOk && helperTextPassword !== '') {
            setHelperTextPassword('');
        }

        if (!isPasswordConfirmOk && helperTextPasswordConfirm === '' && confirmPassword !== '') {
            setHelperTextPasswordConfirm(t('signin.error_password_confirm'));
        } else if (isPasswordConfirmOk && helperTextPasswordConfirm !== '') {
            setHelperTextPasswordConfirm('');
        }

        return isPasswordOk && isPasswordConfirmOk;
    }

    const handleUpdatePassword = async () => {
        try {
            setIsLoading(true);
            
            if (code)
                await forgotPasswordUpdate(code, password, confirmPassword);

            setIsPasswordUpdated(true);
            setIsLoading(false);
        } catch (error) {
            console.error(error);
            throw error;
        }
    }

    useEffect(() => {
        if (!code) {
            navigate('/error');
        }
    }, [code, navigate]);
    
    return (
        <div className={styles.container}>
            <div className={styles.card}>
                { !isPasswordUpdated &&
                    <>
                        <CustomTitle className={styles.title}>{t('forgot_password.title')}</CustomTitle>
                
                        { isLoading &&
                            <div className={styles.loader}>
                                <CustomLoader isLoading={isLoading} loaderType="circular" />
                            </div>
                        }

                        { !isLoading &&
                            <div className={styles.containerInputs}>
                                <CustomInputText id='password' textValue={password} setTextValue={setPassword} label={t('account.informations.new_password')} type='password' helperText={helperTextPassword} error={helperTextPassword !== ''} />
                                <CustomInputText id='confirmPassword' textValue={confirmPassword} setTextValue={setConfirmPassword} label={t('account.informations.new_password_confirm')} type='password' helperText={helperTextPasswordConfirm} error={helperTextPasswordConfirm !== ''} />
                                <CustomButton onClick={() => handleUpdatePassword()} disabled={!isPasswordOk()}>{t('general.confirm')}</CustomButton>
                            </div>
                        }
                    </>
                }

                { isPasswordUpdated &&
                    <>
                        <CustomTitle className={styles.title}>{t('forgot_password.password_updated')}</CustomTitle>
                        <CustomButton className={styles.btn} onClick={() => { navigate('/login') }}>{ t('signin.go_to_login_page') }</CustomButton>
                    </>
                }
            </div>
        </div>
    );
}

export default ForgotPasswordUpdate;